import { BADGE, BadgeType } from '@qlevr/shared/constants';
import { ProductPromotionInfoInterface } from '@qlevr/shared/interfaces';
import { cn } from '@qlevr/shared/utilities';
import { ProductPromotionInfoTooltip } from './product-promotion-info-tooltip';

interface ProductPromotionBadgeProps {
  promotionInfo: ProductPromotionInfoInterface | null;
  theme?: BadgeType;
  className?: string;
  titleClassName?: string;
  subtitleClassName?: string;
}

export function ProductPromotionBadge({
  promotionInfo,
  theme = BADGE.warm,
  className,
  titleClassName,
  subtitleClassName,
}: ProductPromotionBadgeProps) {
  if (!promotionInfo) {
    return null;
  }

  // Don't render if neither title nor subtitle exists
  if (!promotionInfo.title && !promotionInfo.subtitle) {
    return null;
  }

  const hasInfoMessage = promotionInfo.showInfoMessage && promotionInfo.infoMessage;

  return (
    <div
      className={cn(
        theme,
        'promo-message relative flex w-fit justify-center gap-1 rounded-full border px-6 py-2 font-semibold',
        className,
      )}
    >
      <div className="flex flex-col">
        {promotionInfo.title && (
          <span className={cn('promotion-badge_title text-base', titleClassName)}>{promotionInfo.title}</span>
        )}
        {promotionInfo.subtitle && (
          <span className={cn('promotion-badge_subtitle text-xs leading-tight', subtitleClassName)}>
            {promotionInfo.subtitle}
          </span>
        )}
      </div>

      {hasInfoMessage && promotionInfo.infoMessage && (
        <ProductPromotionInfoTooltip infoMessage={promotionInfo.infoMessage} />
      )}
    </div>
  );
}
